import Vue from "vue";
import vConsole  from 'vconsole';
import Clipboard from "clipboard";
import WandLibReport, { addModEvent, bindMod } from "@wand/wand_lib_intel_report";
import UAParser from "ua-parser-js"

import { isInIntlBrowser, IsTest } from "@/utils/tools";
import { game_id } from "@/utils/const";
import reportData from "@/utils/reportData";
import { getVertifyCod, registerWithCode, getShareCode } from "@/api/modules/page";
import LOGIN from "@/utils/login";
import { initServetime } from "@/api";

import './style.css'

Vue.config.productionTip = false;
Vue.use(WandLibReport, [
  {
    type: "google",
    params: { id: "UA-250422088-1" },
  },
  {
    type: "google",
    params: {"id":"G-B4D2985D2B"},
  },
  {
    type: "tlog",
    params: {
      "X-Language": "kr",
      "X-Gameid": '8',
      "X-Source":"pc_web",
      "X-Areaid":""
    },
  },
]);
if (IsTest) {
  new vConsole();
}
// reportTlog({
//   action: "five_black_home_page",
//   ext_content: { url: location.href },
// })
new Vue<any>({
  el: "#app",
  data() {
    return {
      is_login: false,
      user_id: '',
      invite_url: location.href,

      user_hp: undefined,
      privacyAgree: false,
      above18Agree: false,
      verificationCode: undefined,
      watingTime: 0,

      invite_cnt: 0, //邀请人数
      self_code: undefined, // 自己的邀请码
      in_code: undefined, // 输入的邀请码

      fixedBtnOpen: true,

      modal_stepPop1: false,
      modal_stepPop2: false,
      modal_stepPop3: false,
      modal_stepPop4: false,
      modal_stepPop5: false,

      show_modal: false,
      message: '',
    }
  },
  computed: {
    userAgentInfo() {
      const parser = new UAParser();
      return parser.getResult();
    },
    messageStyle() {
      return { display: this.show_modal ? 'flex !important' : 'none' };
    },
  },
  watch: {
    is_login(val){
      if (!val) return;
      this.generateShareCode()
    },
   
  },
  async created(){
    console.log('created')
    window.showMessgae = this.showMessgae
    addModEvent(-1, reportData);
    bindMod(this, -1)
    await initServetime();
    this.init()
  },
  mounted(){
    this.initCopy();
    this.initLoginShareCopy();
    console.log('mounted')
    this.$wreport && this.$wreport("show");
    if (this.$wreport){
      const temp = this;
      window.$(window).on('load', function() {
        const allchanel: Element[] = window.$('.sns li a img');
        for(const element of allchanel){
          const chanel = element.getAttribute('alt');
          element.addEventListener('click', function() {
            temp.$wreport('media', { channel_name: chanel })
          })
        }
      })
    }
    window.$wreport = this.$wreport.bind(this)
  },
  methods: {
    init(){
      this.is_login = LOGIN.checkLogin();
      const data = LOGIN.info();
      this.user_id = data.user_id;
      this.user_hp = data.phone;
    },
    showMessgae(text: string) {
      this.show_modal = true;
      this.message = text;
    },
    hideMessgae(){
      this.show_modal = false;
    },
    closeFixedBtn() {
      this.fixedBtnOpen = false
    },
    async handleLogin() {
      if(!this.user_hp) {
        this.showMessgae('잘못된 휴대폰 번호입니다.');
        return;
      }
      const user_hp = this.user_hp.split('-').join('');
      if( user_hp == "" || user_hp.length !== 8 ) {
        this.showMessgae('잘못된 휴대폰 번호입니다.');
        return;
      }
      
      if( !this.verificationCode ||  this.verificationCode.length !== 6) {
        this.showMessgae('인증번호를 입력하세요.');
        return;
      }
      
      if(!this.privacyAgree) {
        this.showMessgae('개인정보 수집 및 이용에 동의해주세요.');
        return;
      }
      
      if( !this.above18Agree ) {
        this.showMessgae('만 18세 이상 이용 등급에 동의해주세요.');
        return;
      }
      this.$wreport && this.$wreport("login");
      const code = await LOGIN.login({
        game_id,
        phone: user_hp,
        auth_code: this.verificationCode,
        // privacyAgree: this.privacyAgree,
        // above18Agree: this.above18Agree,
      });
      this.$wreport && this.$wreport("loginResult", { ret: code });
      if (LOGIN.checkLogin()) {
        const data = LOGIN.info();
        this.user_id = data.user_id;
        this.is_login = true
        this.showMessgae('로그인에 성공했습니다.');
        // window.location.reload();
      }
    },
    async handleGetCode() {
      if (this.watingTime > 0) {
        return;
      }
      if(!this.user_hp) {
        this.showMessgae('잘못된 휴대폰 번호입니다.');
        return;
      }
      const user_hp = this.user_hp.split('-').join('');
      // 号码固定8位
      if( user_hp == "" || user_hp.length !== 8 ) {
        this.showMessgae('잘못된 휴대폰 번호입니다.');
        return;
      }
      this.$wreport && this.$wreport("verify");
      const res = await getVertifyCod({
        phone: user_hp,
        game_id,
        
      })
      if (!res || res.code !== 0 || !res.data) {
        return;
      }
      this.showMessgae('인증번호가 발송됐습니다.');
      const { expire_time } =  res.data;
      this.countdown(expire_time);
    },
    countdown(counttime: number) {
      this.watingTime = counttime;
      let interval = setInterval(() => {
        this.watingTime -= 1;
        if (this.watingTime <= 0) {
          this.watingTime = 0;
          clearInterval(interval);
        }
      }, 1000);
    },
    async generateShareCode() {
      if( !this.is_login ) {
        this.showMessgae('먼저 로그인 해주세요.');
        return;
      }
      const res = await getShareCode();
      // if (!res || !res.data) {
      //   this.showMessgae('에러가 발생했습니다.');
      //   return;
      // }

      const { code, data } =  res;
      if(code === 0) {
        const { share_code, share_num } = data;
        this.self_code = share_code;
        this.invite_cnt = share_num;
        return;
      }
      // else {
      //   // this.showMessgae('초대코드를 이미 생성하셨습니다');
      //   window.$('.modal_stepPop4').removeClass('hidden');
      // }
    },
    async submitShareCode() {
      if( !this.is_login ) {
        this.showMessgae('먼저 로그인 해주세요.');
        return;
      }
      
      if( !this.in_code) {
        this.showMessgae('초대코드를 입력하세요.');
        return;
      }
      this.$wreport && this.$wreport("registerFriend");
      const res = await registerWithCode({ share_code: this.in_code })
      // if (!res) {
      //   this.showMessgae('에러가 발생했습니다.');
      //   return;
      // }
      
      const { code } =  res;
      this.$wreport && this.$wreport("registerResult", { ret: code });
      if(code === 0) {
        // window.$('.modal_stepPop5').removeClass('hidden');
        this.showMessgae('초대코드가 등록되었습니다.');
        return;
      }
      // else if (code === 99){
      //   this.showMessgae('이미 동료와 함께하고 계십니다.');
      //   return;
      // } else {
      //   window.$('.modal_stepPop4').removeClass('hidden');
      // }
    },
    initCopy() {
      return new Promise((resolve, reject) => {
        if (!this.clip) {
          this.clip = new Clipboard(document.getElementById('btn_invite_code')!, {
            text: () => this.self_code,
          });
        }
        this.clip.on('error', () => {
          this.showMessgae('복제 실패');
          reject();
        });
        this.clip.on('success', () => {
          this.showMessgae('초대코드가 복사됐습니다.');
          resolve(true);
        });
      });
    },
    initLoginShareCopy() {
      return new Promise((resolve, reject) => {
        if (!this.loginShareClip) {
          this.loginShareClip = new Clipboard(document.getElementById('login_after_share')!, {
            text: () => `${this.self_code || ""} ${location.href}`,
          });
        }
        // this.loginShareClip.on('error', () => {
        //   this.showMessgae('복제 실패');
        //   reject();
        // });
        // this.loginShareClip.on('success', () => {
        //   this.showMessgae('초대코드가 복사됐습니다.');
        //   resolve(true);
        // });
      });
    },
    logout(){
      LOGIN.logout();
      this.init()
    }
  }
});
